export const BIRTA_SESSION_STORAGE_KEY = 'birta.session.v2'
const BIRTA_LANGUAGE_STORAGE_KEY = 'birta.language'

export const clearBirtaBrowserState = (): void => {
  try {
    window.localStorage.removeItem(BIRTA_SESSION_STORAGE_KEY)
    window.localStorage.removeItem(BIRTA_LANGUAGE_STORAGE_KEY)
    window.sessionStorage.removeItem(BIRTA_SESSION_STORAGE_KEY)
  }
  catch {
    // Ignore storage access errors (private mode / disabled storage)
  }
}
